export const DISPLAY_VISIT_DATA_LOADING = "DISPLAY_VISIT_DATA_LOADING";
export const DISPLAY_VISIT_DATA = "DISPLAY_VISIT_DATA";
